module.exports = {"standard":{"armorClass":0,"attackBonus":0,"hitPoints":1,"damage":1,"savingThrows":0,"spellDC":0,"perception":0,"initiative":0,"stealth":0},"minion":{"armorClass":-2,"attackBonus":-2,"hitPoints":0.2,"damage":0.75,"savingThrows":-2,"spellDC":-2,"initiative":0,"perception":0,"stealth":0},"elite":{"armorClass":2,"attackBonus":2,"hitPoints":2,"damage":1,"savingThrows":2,"spellDC":2,"perception":2,"initiative":2,"stealth":2},"solo":{"armorClass":2,"attackBonus":2,"hitPoints":4,"damage":1,"savingThrows":2,"spellDC":2,"perception":4,"initiative":4,"stealth":2}}


//////////////////
// WEBPACK FOOTER
// ./src/data/types.json
// module id = LH/+
// module chunks = 1